export const MAIL_TEMPLATE_SYSTEM_NAMES = {
  STUDENT_BULK_ADJUST_INTERVIEW_AG: "student_bulk_adjust_interview_ag",
  STUDENT_ADJUST_INTERVIEW_PLUS: "student_adjust_interview_plus"
};

export const EMAIL_NOTIFICATION_RECIPIENT_TYPE = {
  ENTERPRISE: "enterprise",
  BIC: "bic"
} as const;

export const ADJUST_INTERVIEW_SYSTEM_NAMES = {
  ENTERPRISE_AG: "student_bulk_adjust_interview_ag",
  ENTERPRISE_PLUS: "student_adjust_interview_plus",
  STUDENT_AG: "student_adjust_interview_student_only_ag",
  STUDENT_PLUS: "student_adjust_interview_student_only_plus",
  STUDENT_ADJUST_SUB_SCREENING_COMPANY: "student_adjust_subscreening_company",
  STUDENT_ADJUST_SUB_SCREENING_STUDENT_ONLY: "student_adjust_subscreening_student",
  STUDENT_SCREENING_REQUEST_NOTIFY: "student_screening_request_notify_student",
  STUDENT_SUB_SCREENING_REQUEST_NOTIFY: "student_sub_screening_request_notify_student",
};
